import React from 'react';
import EventEmitter, { SHOULD_CALC_SIZE } from '../../helpers/EventEmitter';
import RightContent from './RightContent';
import Responsive from '../../common/responsive/Responsive';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REDUCER_NAME } from './reducer';
import { withComponentId } from './../../common/ComponentIdContext';
import BarChart from './BarChart';
import StatChart from './StatChart';

const XS_SIZE = 720;

class Content extends React.Component {
  state = {
    tableHeight: 0,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { timeAndSaleData } = this.props;
    if (timeAndSaleData !== prevProps.timeAndSaleData) {
      EventEmitter.dispatch(SHOULD_CALC_SIZE);
    }
  }

  onSize = size => {
    this.setState({ tableHeight: size.height });
  };

  render() {
    const { component = {}, componentId, isChart, currentTab } = this.props;

    return (
      <Responsive
        component={component}
        margin={5}
        offsetWidth={41}
        XS_SIZE={XS_SIZE}
        childrenClassName={['', 'flex-fill']}
        appendClass={
          component.width <= XS_SIZE ? 'flex-column flex-wrap-init' : 'flex-row'
        }
      >
        {width => (
          <div className="left-content">
            {currentTab === 1 ? (
              <BarChart
                height={component.height}
                currentTab={currentTab}
                width={width}
                componentId={componentId}
                onSize={this.onSize}
              />
            ) : (
              <StatChart
                height={component.height}
                width={width}
                currentTab={currentTab}
              />
            )}
          </div>
        )}
        {width => (
          <div className="ts-table d-flex flex-fill h-100" style={{ width }}>
            <RightContent
              isChart={isChart}
              width={width}
              tableHeight={this.state.tableHeight}
            />
          </div>
        )}
      </Responsive>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    component: state[REDUCER_NAME].listMultiComponent[componentId].component,
    timeAndSaleData:
      state[REDUCER_NAME].listMultiComponent[componentId].timeAndSaleData
        .timeAndSales,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(Content);
